import React from 'react';
import {
    GridToolbarContainer,
    GridToolbarProps,
} from '@mui/x-data-grid-pro';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';

interface ToolbarReportOverviewProps extends GridToolbarProps {
    searchValue?: string;
    onSearchChange?: (value: string) => void;
}

const ToolbarReportOverview = ({
    searchValue = '',
    onSearchChange,
}: ToolbarReportOverviewProps) => {
    const { t } = useTranslation();
    const theme = useTheme();


    return (
        <GridToolbarContainer
            sx={{
                justifyContent: 'flex-start',
                padding: 1,
                minHeight: 56
            }}
        >
            <Box sx={{ width: 300, marginLeft: 1 }}>
                <TextField
                    placeholder={t('components.searchBar.searchBox')}
                    size="small"
                    fullWidth
                    value={searchValue}
                    onChange={(e) => onSearchChange?.(e.target.value)}
                    sx={{
                        '& .MuiInputBase-root': {
                            height: 50,
                            paddingRight: '12px'
                        },
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: theme.palette.divider
                            }
                        }
                    }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                {searchValue === '' ? (
                                    <SearchIcon fontSize="small" />
                                ) : (
                                    <IconButton
                                        size="small"
                                        onClick={() => onSearchChange?.('')}
                                    >
                                        <ClearIcon fontSize="small" />
                                    </IconButton>
                                )}
                            </InputAdornment>
                        ),
                    }}
                />
            </Box>
        </GridToolbarContainer>
    );
};

export default ToolbarReportOverview;
